/**
 * Normalize Capacitor PushNotifications permission states for UI.
 * Plugin receive values: prompt | prompt-with-rationale | granted | denied.
 */

export const PERMISSION = {
  PROMPTABLE: 'promptable',
  GRANTED: 'granted',
  DENIED: 'denied',
  UNSUPPORTED: 'unsupported',
};

export function normalizeReceive(receive, { native = true, platform = 'web' } = {}) {
  if (!native || platform === 'web') {
    return PERMISSION.UNSUPPORTED;
  }
  const value = String(receive || '').toLowerCase();
  if (value === 'granted') return PERMISSION.GRANTED;
  if (value === 'denied') return PERMISSION.DENIED;
  if (value === 'prompt' || value === 'prompt-with-rationale') {
    return PERMISSION.PROMPTABLE;
  }
  return PERMISSION.PROMPTABLE;
}

export function isPromptable(state) {
  return state === PERMISSION.PROMPTABLE;
}

export function osDenied(state) {
  return state === PERMISSION.DENIED;
}
